module.exports = __webpack_public_path__ + "static/govbrasil-8f958068fca7ca24836d6f854fdd81e2.svg";